


























































import CompareService from '~/services/compare/CompareService'
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  PropType,
  ref,
  useRouter,
  nextTick
} from '~/utils/nuxt3-migration'
import { Timeout } from '~/models/timing/timeout'
import { useUserAgent } from '~/compositions/user-agent'
import { Classified } from '~/models/classified/types'
import { useI18n } from '~/compositions/i18n'
import { useDep } from '~/compositions/dependency-container'
import { useSnackbar } from '~/compositions/snackbar'
import { ciCompare } from '~/icons/source/solid/compare'
import { useScroll } from '~/compositions/scroll'

export default defineComponent({
  props: {
    classifiedId: {
      type: Number as PropType<Classified['id']>,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    let popoverTimeout: Timeout
    const isPopoverVisible = ref(false)
    const isLoading = ref(false)
    const compareIds = ref<number[]>([])

    const { isPc } = useUserAgent()
    const snackbar = useSnackbar()
    const { scrollToTop } = useScroll()
    const { t } = useI18n()
    const router = useRouter()
    const compareService = useDep(CompareService)

    onBeforeUnmount(() => {
      if (popoverTimeout) {
        clearTimeout(popoverTimeout)
      }
    })

    const buttonTitle = computed(() =>
      props.active ? t('remove from comparison') : t('add to comparison list')
    )

    async function onClick(e: Event) {
      emit('click', e)

      if (!props.classifiedId) {
        return
      }

      isLoading.value = true
      const isActive = props.active

      try {
        const data = isActive
          ? await compareService.removeClassifiedFromCompare(props.classifiedId)
          : await compareService.addClassifiedToCompare(props.classifiedId)

        compareIds.value = data.compareIds

        emit('change', !isActive)
        emit('update:compareIds', data.compareIds)

        if (isPc.value) {
          if (popoverTimeout) {
            clearTimeout(popoverTimeout)
          }

          isPopoverVisible.value = false
          await nextTick()
          isPopoverVisible.value = true

          popoverTimeout = setTimeout(() => {
            isPopoverVisible.value = false
          }, 3000)
        } else {
          snackbar.success(isActive ? t('removed from') : t('added to'), {
            timeout: 1800,
            classes: ['action-button-as-text'],
            action: {
              text: t('comparison') as string,
              callback: () => {
                scrollToTop()
                router.push({
                  name: '__compare',
                  query: {
                    id: data.compareIds
                  }
                })
              }
            }
          })
        }
      } catch (err) {
        const errorMessage =
          (err as any).response?.data?.error || t('something went wrong')
        snackbar.error(errorMessage)
      } finally {
        isLoading.value = false
      }
    }

    function onCompareLinkClick() {
      isPopoverVisible.value = false
    }

    return {
      ciCompare,
      compareIds,
      isPc,
      buttonTitle,
      isPopoverVisible,
      isLoading,
      onClick,
      onCompareLinkClick
    }
  }
})
